// PatternsManager

import * as $ from 'jquery';
import * as _ from 'underscore';

export class PatternsManager {
    private static PatternList = {
        Solid: { code: 0, text: 'Solid' },
        DiagonalRight: { code: 1, text: 'Diagonal Right' },
        DiagonalRightWide: { code: 2, text: 'Diagonal Right Wide' },
        DiagonalLeft: { code: 3, text: 'Diagonal Left' },
        DiagonalLeftWide: { code: 4, text: 'Diagonal Left Wide' },
        HorizontalLines: { code: 5, text: 'Horizontal Lines' },
        HorizontalLinesWide: { code: 6, text: 'Horizontal Lines Wide' },
        VerticalLines: { code: 7, text: 'Vertical Lines' },
        VerticalLinesWide: { code: 8, text: 'Vertical Lines Wide' },
        Checkered: { code: 9, text: 'Checkered' },
        CheckeredWide: { code: 10, text: 'Checkered Wide' }, //  CheckeredLarge = 10
        CheckeredDiagonal: { code: 14, text: 'Checkered Diagonal' },
        DotsSmall: { code: 11, text: 'Dots Small' },
        DotsMedium: { code: 12, text: 'Dots Medium' },
        DotsLarge: { code: 13, text: 'Dots Large' }
    };

    public static defaultPattern = 'Solid';

    public static generatePatternValueList() {
        let values = [];
        for (let key in PatternsManager.PatternList) {
            values.push(key);
        }
        return values;
    }

    //LL: used
    public static generatePatternDisplayList() {
        let disp = [];
        for (let key in PatternsManager.PatternList) {
            disp.push(PatternsManager.PatternList[key].text);
        }
        return disp;
    }

    public static getPatternByCode(patternCode) {
        let patternKey = _.findKey(PatternsManager.PatternList, (p: any) => {
            return p.code === patternCode;
        });
        return patternKey;
    }

    // ========== Canvas =============

    private static createPattern_Canvas_checkered(patternCanvas, color1, color2, rectSize) {
        let pctx = patternCanvas.getContext('2d');
        //     rect: l,t,w,h
        let contextSize = rectSize * 2;
        pctx.fillStyle = color1;
        pctx.fillRect(0, 0, contextSize, contextSize);
        pctx.fillStyle = color2;
        pctx.fillRect(0, 0, rectSize, rectSize);
        pctx.fillRect(rectSize, rectSize, rectSize, rectSize);
    }

    private static createPattern_Canvas_checkeredSmall(patternCanvas, color1, color2) {
        PatternsManager.createPattern_Canvas_checkered(patternCanvas, color1, color2, 4);
    }

    private static createPattern_Canvas_checkeredWide(patternCanvas, color1, color2) {
        PatternsManager.createPattern_Canvas_checkered(patternCanvas, color1, color2, 6);
    }

    private static createPattern_Canvas_checkeredDiagonal(patternCanvas, color1, color2) {
        let pctx = patternCanvas.getContext('2d');
        let contextSize = patternCanvas.width; //8
        let rectSize = patternCanvas.width / 2;

        pctx.fillStyle = color1;
        pctx.fillRect(0, 0, contextSize, contextSize);
        pctx.fillStyle = color2;
        pctx.beginPath();
        pctx.moveTo(0, 0);
        pctx.lineTo(rectSize, rectSize);
        pctx.lineTo(contextSize, 0);
        pctx.closePath();
        pctx.fill();
        pctx.beginPath();
        pctx.moveTo(0, contextSize);
        pctx.lineTo(rectSize, rectSize);
        pctx.lineTo(contextSize, contextSize);
        pctx.closePath();
        pctx.fill();
    }

    private static createPattern_Canvas_horizontalLines(patternCanvas, color1, color2) {
        let pctx = patternCanvas.getContext('2d');
        let contextW = patternCanvas.width;
        let contextH = patternCanvas.height;
        let lineSize = patternCanvas.height / 2;

        pctx.fillStyle = color1;
        pctx.fillRect(0, 0, contextW, contextH);
        pctx.strokeStyle = color2;
        pctx.lineWidth = lineSize;
        pctx.moveTo(0, lineSize);
        pctx.lineTo(contextW, lineSize);
        //   make the line visibile with the stroke color:
        pctx.stroke();
    }

    private static createPattern_Canvas_verticalLines(patternCanvas, color1, color2) {
        let pctx = patternCanvas.getContext('2d');
        let contextW = patternCanvas.width;
        let contextH = patternCanvas.height;
        let lineSize = patternCanvas.width / 2;

        pctx.fillStyle = color1;
        pctx.fillRect(0, 0, contextW, contextH);
        pctx.strokeStyle = color2;
        pctx.lineWidth = lineSize;
        pctx.moveTo(lineSize, 0);
        pctx.lineTo(lineSize, contextW);
        //   make the line visibile with the stroke color:
        pctx.stroke();
    }

    private static createPattern_Canvas_diagRight(patternCanvas, color1, color2) {
        let pctx = patternCanvas.getContext('2d');
        //  4 * 4 or 8*8  20
        let contextSize = patternCanvas.width;
        let lineSize = (contextSize - 1) / 2; // 8->3  20->9

        pctx.fillStyle = color1;
        pctx.fillRect(0, 0, contextSize, contextSize);

        pctx.strokeStyle = color2;
        pctx.lineWidth = lineSize;
        pctx.moveTo(0, contextSize - 1);
        pctx.lineTo(contextSize - 1, 0);
        //   make the line visibile with the stroke color:
        pctx.stroke();

        //  lower angle:
        pctx.moveTo(0, contextSize - 1 + contextSize);
        pctx.lineTo(contextSize - 1 + contextSize, 0);
        //  upper angle:
        pctx.moveTo(-contextSize, contextSize - 1);
        pctx.lineTo(contextSize - 1, -contextSize);
        pctx.stroke();

        //  bad, unevenly:
        //lineSize = lineSize/2;  // 1  2  20->5
        //pctx.lineWidth = lineSize;
        //pctx.moveTo(0, lineSize);
        //pctx.lineTo(lineSize, 0);
        //pctx.moveTo(contextSize - lineSize, contextSize);
        //pctx.lineTo(contextSize, contextSize - lineSize);
        ////   make the line visibile with the stroke color:
        //pctx.stroke();
    }

    private static createPattern_Canvas_diagLeft(patternCanvas, color1, color2) {
        let pctx = patternCanvas.getContext('2d');
        //  4 * 4 or 8*8  20
        let contextSize = patternCanvas.width;
        let lineSize = (contextSize - 1) / 2; // 8->3  20->9

        pctx.fillStyle = color1;
        pctx.fillRect(0, 0, contextSize, contextSize);

        pctx.strokeStyle = color2;
        pctx.lineWidth = lineSize;
        pctx.moveTo(0, 0);
        pctx.lineTo(contextSize, contextSize);
        //   make the line visibile with the stroke color:
        pctx.stroke();

        //  lower angle:
        pctx.moveTo(-contextSize, 0);
        pctx.lineTo(contextSize - 1, contextSize - 1 + contextSize);
        //  upper angle:
        pctx.moveTo(0, -contextSize);
        pctx.lineTo(contextSize - 1 + contextSize, contextSize - 1);
        pctx.stroke();

        //  bad, unevenly:
        //lineSize = lineSize/2;  // 1  2
        //pctx.lineWidth = lineSize;
        //pctx.moveTo(0, contextSize - lineSize);
        //pctx.lineTo(lineSize, contextSize);
        //pctx.moveTo(contextSize - lineSize, 0);
        //pctx.lineTo(contextSize, lineSize);
        ////   make the line visibile with the stroke color:
        //pctx.stroke();
    }

    private static createPattern_Canvas_dotsSmall(patternCanvas, color1, color2) {
        let pctx = patternCanvas.getContext('2d');
        //  2 * 2
        let contextSize = patternCanvas.width;
        let dotSize = contextSize / 2; // 1

        pctx.fillStyle = color1;
        pctx.fillRect(0, 0, contextSize, contextSize);
        pctx.strokeStyle = color2;
        pctx.lineWidth = dotSize;
        pctx.moveTo(0, 0);
        pctx.lineTo(0, dotSize);
        pctx.stroke();
        pctx.moveTo(dotSize, dotSize);
        pctx.lineTo(dotSize, contextSize);
        pctx.stroke();
    }

    //  = DotsMedium
    private static createPattern_Canvas_circles(patternCanvas, color1, color2) {
        let pctx = patternCanvas.getContext('2d');
        //  8 * 8
        let contextSize = patternCanvas.width;
        let radius = (contextSize - 2) / 2; // 8 -> 3

        pctx.fillStyle = color1;
        pctx.fillRect(0, 0, contextSize, contextSize);

        pctx.arc(contextSize / 2, contextSize / 2, radius, 0, 2 * Math.PI, false);
        pctx.fillStyle = color2;
        pctx.fill();
        //pctx.lineWidth = 5;
        //pctx.strokeStyle = "black";
        //pctx.stroke();

        //To create an arc with HTML5 Canvas, we can use the arc() method.
        // Arcs are defined by a center point, a radius, a starting angle, an ending angle,
        // and the drawing direction (either clockwise or anticlockwise).
        // Arcs can be styled with the lineWidth, strokeStyle, and lineCap properties.

        //An arc is nothing more than a section of the circumference of an imaginary circle.
        // This imaginary circle can be defined by x, y, and radius.
        //
        //Next, we can define the arc itself with two points along the imaginary circle's
        // circumference defined by startAngle and endAngle. These two angles are defined
        // in radians and form imaginary lines that originate from the center of the circle
        // and intersect the ends of the arc that we wish to create.
        //
        //The final argument of the arc method is antiClockwise which defines the direction
        // of the arc path between its two ending points. Unless otherwise specified,
        // this argument is defaulted to false, which causes the arc to be drawn clockwise.
        //
        //Note: Alternatively, we can also create an arc using the arcTo() method
        // which is used for creating rounded corners in a path. Click here to read more.

        //http://www.java2s.com/Tutorials/Javascript/Canvas/Shape/Draw_a_circle_in_JavaScript.htm
        //context.arc(canvas.width / 2, canvas.height / 2, 70, 0, 2 * Math.PI, false);
        //context.fillStyle = "#8ED6FF";
        //context.fill();
        //context.lineWidth = 5;
        //context.strokeStyle = "black";
        //context.stroke();
    }

    private static createPatternCanvas(contextWidth, contextHeight?) {
        let H = contextHeight == null ? contextWidth : contextHeight;

        let patternCanvas: HTMLCanvasElement;

        patternCanvas = document.createElement('canvas');
        patternCanvas.width = contextWidth;
        patternCanvas.height = H;

        return patternCanvas;
    }

    //LL: for GoJS.    And also here
    public static deletePatternCanvas(id) {
        let elem = $(id);
        elem.find('canvas#pattern').remove();
    }

    //LL: public for GoJS
    public static getPatternCanvas(pattern, color1, color2) {
        let patternCanvas: HTMLCanvasElement;
        let isDefaultPattern = false;
        let contextSize;
        switch (pattern) {
            case 'DiagonalRight':
                //contextSize = 4;
                contextSize = 8;
                patternCanvas = PatternsManager.createPatternCanvas(contextSize);
                PatternsManager.createPattern_Canvas_diagRight(patternCanvas, color1, color2);
                break;
            case 'DiagonalRightWide':
                //contextSize = 8;
                //contextSize = 20;  // bad in compact, max 13 - height of middle bar
                contextSize = 12;
                patternCanvas = PatternsManager.createPatternCanvas(contextSize);
                PatternsManager.createPattern_Canvas_diagRight(patternCanvas, color1, color2);
                break;
            case 'DiagonalLeft':
                //contextSize = 4;
                contextSize = 8;
                patternCanvas = PatternsManager.createPatternCanvas(contextSize);
                PatternsManager.createPattern_Canvas_diagLeft(patternCanvas, color1, color2);
                break;
            case 'DiagonalLeftWide':
                //contextSize = 8;
                //contextSize = 20;  // bad in compact, max 13 - height of middle bar
                contextSize = 12;
                patternCanvas = PatternsManager.createPatternCanvas(contextSize);
                PatternsManager.createPattern_Canvas_diagLeft(patternCanvas, color1, color2);
                break;
            case 'VerticalLines':
                contextSize = 4;
                patternCanvas = PatternsManager.createPatternCanvas(contextSize);
                PatternsManager.createPattern_Canvas_verticalLines(patternCanvas, color1, color2);
                break;
            case 'VerticalLinesWide':
                patternCanvas = PatternsManager.createPatternCanvas(8, 4);
                PatternsManager.createPattern_Canvas_verticalLines(patternCanvas, color1, color2);
                break;
            case 'HorizontalLines':
                contextSize = 4;
                patternCanvas = PatternsManager.createPatternCanvas(contextSize);
                PatternsManager.createPattern_Canvas_horizontalLines(patternCanvas, color1, color2);
                break;
            case 'HorizontalLinesWide':
                patternCanvas = PatternsManager.createPatternCanvas(4, 8);
                PatternsManager.createPattern_Canvas_horizontalLines(patternCanvas, color1, color2);
                break;
            case 'Checkered':
                contextSize = 8;
                patternCanvas = PatternsManager.createPatternCanvas(contextSize);
                PatternsManager.createPattern_Canvas_checkeredSmall(patternCanvas, color1, color2); // 4
                break;
            case 'CheckeredWide':
                contextSize = 12;
                patternCanvas = PatternsManager.createPatternCanvas(contextSize);
                PatternsManager.createPattern_Canvas_checkeredWide(patternCanvas, color1, color2); // 6
                break;
            case 'CheckeredDiagonal':
                contextSize = 8;
                patternCanvas = PatternsManager.createPatternCanvas(contextSize);
                PatternsManager.createPattern_Canvas_checkeredDiagonal(patternCanvas, color1, color2);
                break;
            case 'DotsSmall':
                contextSize = 2;
                patternCanvas = PatternsManager.createPatternCanvas(contextSize);
                PatternsManager.createPattern_Canvas_dotsSmall(patternCanvas, color1, color2);
                break;
            case 'DotsMedium':
                contextSize = 8;
                patternCanvas = PatternsManager.createPatternCanvas(contextSize);
                PatternsManager.createPattern_Canvas_circles(patternCanvas, color1, color2);
                break;
            case 'DotsLarge':
                contextSize = 12;
                patternCanvas = PatternsManager.createPatternCanvas(contextSize);
                PatternsManager.createPattern_Canvas_circles(patternCanvas, color1, color2);
                break;
            default:
                if (pattern == null || pattern === '' || pattern === 'Solid') {
                    isDefaultPattern = true;
                }
        }

        return {
            isDefaultPattern: isDefaultPattern,
            patternCanvas: patternCanvas
        };

        //LL:  don't rem, examples:

        //  context.createPattern(image,"repeat|repeat-x|repeat-y|no-repeat");
        //  image	Specifies the image, canvas, or video element of the pattern to use
        //     type '(HTMLImageElement or HTMLVideoElement or HTMLCanvasElement or ImageBitmap)'

        // try:
        //let patternCanvas = document.createElement('canvas');
        //patternCanvas.width = 8;
        //patternCanvas.height = 8;
        //let pctx = patternCanvas.getContext('2d');
        //  try red squares:
        //pctx.fillStyle = "red";
        //pctx.fillRect(0,0,4,4);

        //  SAMPLE ROTATE:
        //  http://www.html5canvastutorials.com/advanced/html5-canvas-transform-rotate-tutorial/
        //
        //// translate context to center of canvas:
        //context.translate(canvas.width / 2, canvas.height / 2);
        //// rotate 45 degrees clockwise:
        //context.rotate(Math.PI / 4);
        //context.fillStyle = 'blue';
        //context.fillRect(rectWidth / -2, rectHeight / -2, rectWidth, rectHeight);
        // To rotate the HTML5 Canvas, we can use the rotate() transform method.
        // The rotate transformation requires an angle in radians.
        // To define the rotation point, we need to first translate the canvas context such
        // that the top left corner of the context lies on the desired rotation point.
        // In this tutorial, we've translated the canvas context such that the top left corner of the context
        // is directly on the center of the rectangle, which produces a rotation about the center of the rectangle.

        //  try rotate, wrong, don't rem:
        //pctx.translate(patternCanvas.width / 2, patternCanvas.height / 2);
        //pctx.rotate(Math.PI / 4);
    }

    //LL: used in scoreBar.tsx
    public static drawHatchedPolygon_WholeCanvas(
        canvas: HTMLCanvasElement,
        arrowWidth,
        bufferBeforeLen,
        bufferAfterLen,
        bufferColor,
        has_towBefore,
        has_towAfter,
        text,
        textRight,
        pattern,
        backColor,
        foreColor,
        textColor,
        textOutsideColor,
        fontsize,
        StartLabelAbove,
        EndLabelAbove,
        StartLabelBelow,
        EndLabelBelow,
        H3,
        elemHeight,
        elemWidth
    ) {
        let H, W, arrowHeight;
        let X1, X2, wBar;
        let Y1, Y2, hBar;

        let h5 = elemHeight;
        let w5 = elemWidth;
        H = h5;
        W = w5;

        X1 = bufferBeforeLen;
        X2 = W - bufferAfterLen;
        wBar = W - bufferAfterLen - bufferBeforeLen;

        Y1 = H3;
        Y2 = H - H3;
        hBar = H - H3 * 2;
        arrowHeight = Math.round(hBar / 2);

        let context;
        if (canvas != null) {
            context = canvas.getContext('2d');
        }

        let color1 = 'crimson';
        if (backColor != null) color1 = backColor;
        let color2 = 'yellow';
        if (foreColor != null) color2 = foreColor;
        let txtColor = 'blue';
        if (textColor != null) txtColor = textColor;

        if (context != null) {
            // -- draw buffers:  context.fillRect(x,y,width,height);
            context.fillStyle = bufferColor;
            context.fillRect(0, Y1, X1, hBar);
            context.fillRect(X2, Y1, bufferAfterLen, hBar);

            //  -- define points:

            let points = [];
            let arrowWidth2 = arrowWidth * 2;

            if (has_towBefore && has_towAfter) {
                let arrowWidth3 = wBar - arrowWidth;
                points = [
                    { x: X1, y: Y1 + arrowHeight },
                    { x: X1 + arrowWidth, y: Y1 },
                    { x: X1 + arrowWidth3, y: Y1 },
                    { x: X2, y: Y1 + arrowHeight },
                    { x: X1 + arrowWidth3, y: Y2 },
                    { x: X1 + arrowWidth, y: Y2 }
                ];
            } else if (has_towBefore) {
                let arrowWidth3 = wBar - 0;
                points = [
                    { x: X1, y: Y1 + arrowHeight },
                    { x: X1 + arrowWidth, y: Y1 },
                    { x: X1 + arrowWidth3, y: Y1 },
                    { x: X1 + arrowWidth3, y: Y2 },
                    { x: X1 + arrowWidth, y: Y2 }
                ];
            } else if (has_towAfter) {
                let arrowWidth3 = wBar - arrowWidth;
                points = [
                    { x: X1, y: Y1 },
                    { x: X1 + arrowWidth3, y: Y1 },
                    { x: X2, y: Y1 + arrowHeight },
                    { x: X1 + arrowWidth3, y: Y2 },
                    { x: X1, y: Y2 }
                ];
            } else {
                let arrowWidth3 = wBar - 0;
                points = [
                    { x: X1, y: Y1 },
                    { x: X1 + arrowWidth3, y: Y1 },
                    { x: X1 + arrowWidth3, y: Y2 },
                    { x: X1, y: Y2 }
                ];
            }

            //  -- create Pattern:

            let patternCanvas: HTMLCanvasElement;
            let isDefaultPattern = false;

            let pc = PatternsManager.getPatternCanvas(pattern, color1, color2);
            // return { isDefaultPattern: isDefaultPattern, patternCanvas: patternCanvas };
            patternCanvas = pc.patternCanvas;
            isDefaultPattern = pc.isDefaultPattern;

            //  -- actual draw:

            if (isDefaultPattern || patternCanvas == null) {
                if (!isDefaultPattern) {
                    console.log('Scheduler: pattern not found - ' + pattern + ', will be solid');
                }
                context.fillStyle = color1;
            } else {
                let patternFill = context.createPattern(patternCanvas, 'repeat');
                context.fillStyle = patternFill;
                if (patternCanvas != null) {
                    patternCanvas.remove();
                }
                //PatternsManager.deletePatternCanvas(id);
            }

            context.beginPath();
            context.moveTo(points[0].x, points[0].y);
            for (let k = 1; k < points.length; k++) {
                context.lineTo(points[k].x, points[k].y);
            }
            context.closePath();
            context.fill();

            //  - text
            const textPadding = 0; // 3
            let textX = X1 + textPadding;
            if (has_towBefore) textX = X1 + arrowWidth;

            // fontsize may be null  = "small", "x-small"    without px
            context.fillStyle = txtColor;
            //context.strokeStyle = "black";
            //context.lineWidth = 2;
            //   align text horizontally center:
            //context.textAlign = "center";
            context.textAlign = 'left'; //LL: by OE changes canvas and => context is not rebuilt now (React !), but used old. So textAlign is wrong
            //   align text vertically center:
            context.textBaseline = 'middle';
            //context.font = "100px sans-serif";
            context.font = fontsize;
            context.fillText(text, textX, Y1 + arrowHeight);
            //context.strokeText(text, textX, arrowHeight);

            let textX_R;
            if (textRight != null) {
                context.textAlign = 'right';
                textX_R = X2 - textPadding;
                if (has_towAfter) textX_R = X2 - arrowWidth;
                context.fillText(textRight, textX_R, Y1 + arrowHeight);
            }

            // -- 1st and 3d lines:

            //LL: textOutsideColor to draw Above & Below Labels
            if (textOutsideColor != null) txtColor = textOutsideColor;
            context.fillStyle = txtColor;

            textX = X1 + textPadding;
            textX_R = X2 - textPadding;

            context.textBaseline = 'bottom';
            if (StartLabelAbove != null) {
                context.textAlign = 'left';
                context.fillText(StartLabelAbove, textX, Y1);
            }
            if (EndLabelAbove != null) {
                context.textAlign = 'right';
                context.fillText(EndLabelAbove, textX_R, Y1);
            }

            context.textBaseline = 'top';
            if (StartLabelBelow != null) {
                context.textAlign = 'left';
                context.fillText(StartLabelBelow, textX, Y2);
            }
            if (EndLabelBelow != null) {
                context.textAlign = 'right';
                context.fillText(EndLabelBelow, textX_R, Y2);
            }

            // -- remove canvas for pattern:
            if (patternCanvas != null) {
                patternCanvas.remove();
            }
        }
    }

    private static evalTextLineWidth(wtL, wtM, wtR, horizIndent) {
        let W = wtL + wtM + wtR;
        let K = 0;
        if (wtL !== 0 && wtM !== 0 && wtR !== 0) {
            K = 2;
        } else if ((wtL !== 0 && wtM !== 0) || (wtM !== 0 && wtR !== 0) || (wtL !== 0 && wtR !== 0)) {
            K = 1;
        }
        return W + horizIndent * K;
    }

    private static ensureLabelsNeverOverlap(wtL, wtM, wtR, horizIndent, wBar, wRect) {
        let ret: any = {
            normalPos: true,
            remLeftLabel: false,
            remRightLabel: false,
            remMiddleLabel: false
        };

        //LL: The order of Label dropping:  Middle, Right, Left

        //LL: about dropping of Middle Label:
        // Way 1: forget that it is pinned to the Bar's middle.
        //   Bad, when summary text length is inside Bar, but one of left/right text is too long and overlaps middle
        // Way 2: check separately overlapping of Left and Middle, and Right and Middle

        //LL:  use Way 2:  Left-Middle/Right-Middle overlapping
        let overlapMiddle = false;
        if (wtM != 0) {
            let wtM2 = Math.ceil(wtM / 2);
            let wRect2 = Math.floor(wRect / 2);
            let textLineW_LeftHalf = PatternsManager.evalTextLineWidth(wtL, wtM2, 0, horizIndent);
            overlapMiddle = textLineW_LeftHalf > wRect2;
            if (!overlapMiddle) {
                let textLineW_RightHalf = PatternsManager.evalTextLineWidth(0, wtM2, wtR, horizIndent);
                overlapMiddle = textLineW_RightHalf > wRect2;
            }
        }
        //LL:  if overlapMiddle => must drop Middle Label, even if summary length is OK

        let textLineW = PatternsManager.evalTextLineWidth(wtL, wtM, wtR, horizIndent);
        let normalPos = textLineW <= wRect;
        let squeezed = false;

        if (!overlapMiddle) {
            if (normalPos) {
                ret.normalPos = normalPos;
                return ret;
            }

            //  squeezed is enough ?
            squeezed = textLineW <= wBar; // wRect is wBar without 2 arrowWidth
            if (squeezed) {
                ret.normalPos = normalPos; // is false here
                return ret;
            }
        }

        //LL: here summary length exceeds Bar width or Left-Middle/Right-Middle overlapping

        //LL: drop Middle Label:
        if (wtM != 0) {
            wtM = 0;
            ret.remMiddleLabel = true;
            textLineW = PatternsManager.evalTextLineWidth(wtL, wtM, wtR, horizIndent);
            normalPos = textLineW <= wRect;

            if (normalPos) {
                ret.normalPos = normalPos;
                return ret;
            }
            squeezed = textLineW <= wBar; // wRect is wBar without 2 arrowWidth
            if (squeezed) {
                ret.normalPos = normalPos; // is false here
                return ret;
            }
        }

        //LL: drop Right Label:
        if (wtR != 0) {
            wtR = 0;
            ret.remRightLabel = true;
            textLineW = PatternsManager.evalTextLineWidth(wtL, wtM, wtR, horizIndent);
            normalPos = textLineW <= wRect;

            if (normalPos) {
                ret.normalPos = normalPos;
                return ret;
            }
            squeezed = textLineW <= wBar; // wRect is wBar without 2 arrowWidth
            if (squeezed) {
                ret.normalPos = normalPos; // is false here
                return ret;
            }
        }

        //LL: drop Left Label:  Or truncate ?
        if (wtL != 0) {
            wtL = 0;
            ret.remLeftLabel = true; // ?
            textLineW = PatternsManager.evalTextLineWidth(wtL, wtM, wtR, horizIndent);
            normalPos = textLineW <= wRect;

            //if (normalPos) {
            //    ret.normalPos = normalPos;
            //    return ret;
            //}
            //squeezed = (textLineW <= wBar);  // wRect is wBar without 2 arrowWidth
            //if (squeezed) {
            //    ret.normalPos = normalPos;  // is false here
            //    return ret;
            //}

            ret.normalPos = normalPos;
            return ret;
        }

        return ret;
    }

    //LL: used in standplanBar.tsx,  as copy of drawHatchedPolygon_WholeCanvas
    //LL: Additional Colors: borderColor, topStripColor, bottomStripColor;   stripWidth, textVertIndent
    //LL: Additional Labels: LabelMiddle, MiddleLabelAbove, MiddleLabelBelow, LabelRows
    //LL:  buffers and pattern are not needed:  textOutsideColor, foreColor
    //LL:  pattern always 'solid', without Buffers
    //LL:  H3 is Math.floor(H / 3);  Is used for Font,
    public static drawStandplanPolygon(
        canvas: HTMLCanvasElement,
        arrowWidth,
        has_towBefore,
        has_towAfter,
        text,
        textRight,
        backColor,
        textColor,
        borderColor,
        topStripColor,
        bottomStripColor,
        stripWidth,
        textVertIndent,
        font,
        StartLabelAbove,
        EndLabelAbove,
        StartLabelBelow,
        EndLabelBelow,
        LabelMiddle,
        MiddleLabelAbove,
        MiddleLabelBelow,
        LabelRows,
        H3,
        elemHeight,
        elemWidth
    ) {
        let H, W;
        let X1, X2, wBar;
        let Y1, Y2, hBar;
        let arrowHeight;

        H = elemHeight;
        W = elemWidth;

        //LL: new for Text Labels: as old Ys
        let Y1_text, Y2_text, hBar_text;
        let arrowHeight_text;

        X1 = 0;
        X2 = W;
        wBar = W;

        //LL: polygon with full height:
        Y1 = 0;
        Y2 = H;
        hBar = H;
        arrowHeight = Math.round(hBar / 2);

        //  see  const textVertIndent = 2;  //LL: pixels between Strip and Text

        //LL:  stripWidth must be < H/2 !!!   Validator ?
        //LL:  also in standplanBar
        if (stripWidth + textVertIndent >= H / 3) {
            stripWidth = Math.floor(H / 3) - textVertIndent;
        }

        let context;
        if (canvas != null) {
            context = canvas.getContext('2d');
        }

        let color1 = 'crimson';
        if (backColor != null) color1 = backColor;
        let txtColor = 'blue';
        if (textColor != null) txtColor = textColor;
        //LL: new:
        let brdColor = 'black';
        if (borderColor != null) brdColor = borderColor;

        if (context != null) {
            context.lineJoin = 'miter'; //  sharp angle

            //  -- define points:

            let points = [];
            let arrowWidth2 = arrowWidth * 2;

            let stripX1, stripX2; // new

            if (has_towBefore && has_towAfter) {
                let arrowWidth3 = wBar - arrowWidth;
                points = [
                    { x: X1, y: Y1 + arrowHeight },
                    { x: X1 + arrowWidth, y: Y1 },
                    { x: X1 + arrowWidth3, y: Y1 },
                    { x: X2, y: Y1 + arrowHeight },
                    { x: X1 + arrowWidth3, y: Y2 },
                    { x: X1 + arrowWidth, y: Y2 }
                ];
                stripX1 = X1 + arrowWidth;
                stripX2 = X1 + wBar - arrowWidth; // X1 + arrowWidth3 = X1 + wBar - arrowWidth
            } else if (has_towBefore) {
                let arrowWidth3 = wBar - 0;
                points = [
                    { x: X1, y: Y1 + arrowHeight },
                    { x: X1 + arrowWidth, y: Y1 },
                    { x: X1 + arrowWidth3, y: Y1 },
                    { x: X1 + arrowWidth3, y: Y2 },
                    { x: X1 + arrowWidth, y: Y2 }
                ];
                stripX1 = X1 + arrowWidth;
                stripX2 = X1 + wBar;
            } else if (has_towAfter) {
                let arrowWidth3 = wBar - arrowWidth;
                points = [
                    { x: X1, y: Y1 },
                    { x: X1 + arrowWidth3, y: Y1 },
                    { x: X2, y: Y1 + arrowHeight },
                    { x: X1 + arrowWidth3, y: Y2 },
                    { x: X1, y: Y2 }
                ];
                stripX1 = X1;
                stripX2 = X1 + wBar - arrowWidth;
            } else {
                let arrowWidth3 = wBar - 0;
                points = [
                    { x: X1, y: Y1 },
                    { x: X1 + arrowWidth3, y: Y1 },
                    { x: X1 + arrowWidth3, y: Y2 },
                    { x: X1, y: Y2 }
                ];
                stripX1 = X1;
                stripX2 = X1 + wBar;
            }

            context.fillStyle = color1; //LL:  no pattern, always solid

            // for border
            //context.strokeStyle = brdColor;
            //context.lineWidth = 1;

            context.beginPath();
            context.moveTo(points[0].x, points[0].y);
            for (let k = 1; k < points.length; k++) {
                context.lineTo(points[k].x, points[k].y);
            }
            context.closePath();
            context.fill();

            ////  - border, seems must be after Strips
            ////context.strokeStyle = brdColor;
            ////context.lineWidth = 1;
            ////context.beginPath();
            ////context.moveTo(points[0].x, points[0].y);
            ////for (let k = 1; k < points.length; k++) {
            ////    context.lineTo(points[k].x, points[k].y);
            ////}
            ////context.closePath();
            //context.stroke();

            //  - top & bottom strips   stripX1, stripX2
            let dStrip = Math.floor(stripWidth / 2); // round, ceil ?
            if (topStripColor != null) {
                context.strokeStyle = topStripColor;
                context.lineWidth = stripWidth;
                context.beginPath();
                context.moveTo(stripX1, Y1 + dStrip);
                context.lineTo(stripX2, Y1 + dStrip);
                context.stroke();
            }
            if (bottomStripColor != null) {
                context.strokeStyle = bottomStripColor;
                context.lineWidth = stripWidth;
                context.beginPath();
                context.moveTo(stripX1, Y2 - dStrip);
                context.lineTo(stripX2, Y2 - dStrip);
                context.stroke();
            }

            //  - border, seems must be after Strips

            context.strokeStyle = brdColor;
            context.lineWidth = 1;
            context.beginPath();
            context.moveTo(points[0].x, points[0].y);
            for (let k = 1; k < points.length; k++) {
                context.lineTo(points[k].x, points[k].y);
            }
            context.closePath();
            context.stroke();

            //  - text

            //  - text measure:   ctx.measureText(txt).width
            context.font = font; //  "10px sans-serif"
            let LeftW = 0,
                MiddleW = 0,
                RightW = 0;
            let AboveLeftW = 0,
                AboveMiddleW = 0,
                AboveRightW = 0;
            let BelowLeftW = 0,
                BelowMiddleW = 0,
                BelowRightW = 0;
            if (text != null) LeftW = Math.ceil(context.measureText(text).width);
            if (textRight != null) RightW = Math.ceil(context.measureText(textRight).width);
            if (LabelMiddle != null) MiddleW = Math.ceil(context.measureText(LabelMiddle).width);
            if (StartLabelAbove != null) AboveLeftW = Math.ceil(context.measureText(StartLabelAbove).width);
            if (EndLabelAbove != null) AboveRightW = Math.ceil(context.measureText(EndLabelAbove).width);
            if (MiddleLabelAbove != null) AboveMiddleW = Math.ceil(context.measureText(MiddleLabelAbove).width);
            if (StartLabelBelow != null) BelowLeftW = Math.ceil(context.measureText(StartLabelBelow).width);
            if (EndLabelBelow != null) BelowRightW = Math.ceil(context.measureText(EndLabelBelow).width);
            if (MiddleLabelBelow != null) BelowMiddleW = Math.ceil(context.measureText(MiddleLabelBelow).width);

            const horizIndent = 3; // ?
            //let textLineW = PatternsManager.evalTextLineWidth(LeftW, MiddleW, RightW, horizIndent);
            let textLineAboveW = PatternsManager.evalTextLineWidth(AboveLeftW, AboveMiddleW, AboveRightW, horizIndent);
            let textLineBelowW = PatternsManager.evalTextLineWidth(BelowLeftW, BelowMiddleW, BelowRightW, horizIndent);

            let wRect = wBar;
            if (has_towBefore) wRect -= arrowWidth;
            if (has_towAfter) wRect -= arrowWidth;

            //LL:  from Christian:
            // We have also taken steps to ensure text labels never overlap.
            // We do this by first dropping the central label,
            // if it would overlap with the left or right label in a row.
            // If the bar is further compressed, we will also drop the left and/or right label.

            //LL:  about “squeezed format”
            // In Standplan, we allow the labels to overlap the arrow heads,
            // but only if they would otherwise overlap the label at the other end of the same bar
            // (see example of this “squeezed format” in the screenshot below.
            // In the normal situation, the labels are positioned inside the rectangular section of the bar
            // (see “normal position” in the screenshot below).

            //LL: my decision:
            //   if not "normal", first try "squeezed format" (i.e. text on arrows)
            //   if not, drop Middle Label and check for "normal" again. Check for "squeezed" again
            //   if not, do the same with Right and Left Labels
            //LL: maybe check which is longer ?
            //   What to do with last Label, if it is still too long ?  Truncate ? Yes, will be automatically

            //   consider textPadding (see below)  ????????

            let overlapObj = PatternsManager.ensureLabelsNeverOverlap(LeftW, MiddleW, RightW, horizIndent, wBar, wRect);
            //  let ret:any = {normalPos:true, remLeftLabel:false, remRightLabel:false, remMiddleLabel: false}
            let normalPos = overlapObj.normalPos;
            if (overlapObj.remLeftLabel) {
                //text = null;    //  truncate ?  yes, will be automatically
            }
            if (overlapObj.remRightLabel) {
                textRight = null;
            }
            if (overlapObj.remMiddleLabel) {
                LabelMiddle = null;
            }

            let overlapObjAbove = PatternsManager.ensureLabelsNeverOverlap(
                AboveLeftW,
                AboveMiddleW,
                AboveRightW,
                horizIndent,
                wBar,
                wRect
            );
            let normalPosAbove = overlapObjAbove.normalPos;
            if (overlapObjAbove.remLeftLabel) {
                //StartLabelAbove = null;    //  truncate ?  yes, will be automatically
            }
            if (overlapObjAbove.remRightLabel) {
                EndLabelAbove = null;
            }
            if (overlapObjAbove.remMiddleLabel) {
                MiddleLabelAbove = null;
            }

            let overlapObjBelow = PatternsManager.ensureLabelsNeverOverlap(
                BelowLeftW,
                BelowMiddleW,
                BelowRightW,
                horizIndent,
                wBar,
                wRect
            );
            let normalPosBelow = overlapObjBelow.normalPos;
            if (overlapObjBelow.remLeftLabel) {
                //StartLabelBelow = null;    //  truncate ?  yes, will be automatically
            }
            if (overlapObjBelow.remRightLabel) {
                EndLabelBelow = null;
            }
            if (overlapObjBelow.remMiddleLabel) {
                MiddleLabelBelow = null;
            }

            //  --- actual draw text -------------

            const textPadding = 2; // 0;

            context.fillStyle = txtColor;

            let rowCnt = 3;
            if (LabelRows != null && LabelRows.rowCnt > 0) {
                rowCnt = LabelRows.rowCnt;
            }
            //LL:  H3 was for rowCnt = 3
            //LL:  now used for FontSize and when rowCnt = 3

            let textX = X1 + textPadding;
            let textX_R = X2 - textPadding;
            let textX_M = X1 + (X2 - X1) / 2;

            if (rowCnt === 1) {
                textX = X1 + textPadding;
                textX_R = X2 - textPadding;

                let normalPosCur = true;
                let labStart, labEnd, labMiddle;

                //LL: one of them is True:
                if (LabelRows.centerRow) {
                    labStart = text;
                    labEnd = textRight;
                    labMiddle = LabelMiddle;
                    normalPosCur = normalPos;
                } else if (LabelRows.aboveRow) {
                    labStart = StartLabelAbove;
                    labEnd = EndLabelAbove;
                    labMiddle = MiddleLabelAbove;
                    normalPosCur = normalPosAbove;
                } else if (LabelRows.belowRow) {
                    labStart = StartLabelBelow;
                    labEnd = EndLabelBelow;
                    labMiddle = MiddleLabelBelow;
                    normalPosCur = normalPosBelow;
                }

                if (normalPosCur) {
                    // the labels are positioned inside the rectangular section of the bar
                    if (has_towBefore) textX = X1 + arrowWidth;
                    if (has_towAfter) textX_R = X2 - arrowWidth;
                }

                Y1_text = Math.round(H / 2);

                context.textBaseline = 'middle'; // align text vertically center
                if (labStart != null) {
                    context.textAlign = 'left';
                    context.fillText(labStart, textX, Y1_text);
                }
                if (labEnd != null) {
                    context.textAlign = 'right';
                    context.fillText(labEnd, textX_R, Y1_text);
                }
                if (labMiddle != null) {
                    context.textAlign = 'center';
                    context.fillText(labMiddle, textX_M, Y1_text);
                }

                return;
            } //  rowCnt === 1
            else if (rowCnt === 2) {
                let normalPosCur1 = true;
                let labStart1, labEnd1, labMiddle1;
                let normalPosCur2 = true;
                let labStart2, labEnd2, labMiddle2;

                //LL: two of them are True: 1 may be Above or Center, 2 may be Below or Center

                if (LabelRows.aboveRow) {
                    labStart1 = StartLabelAbove;
                    labEnd1 = EndLabelAbove;
                    labMiddle1 = MiddleLabelAbove;
                    normalPosCur1 = normalPosAbove;
                } else if (LabelRows.centerRow) {
                    labStart1 = text;
                    labEnd1 = textRight;
                    labMiddle1 = LabelMiddle;
                    normalPosCur1 = normalPos;
                }

                if (LabelRows.belowRow) {
                    labStart2 = StartLabelBelow;
                    labEnd2 = EndLabelBelow;
                    labMiddle2 = MiddleLabelBelow;
                    normalPosCur2 = normalPosBelow;
                } else if (LabelRows.centerRow) {
                    labStart2 = text;
                    labEnd2 = textRight;
                    labMiddle2 = LabelMiddle;
                    normalPosCur2 = normalPos;
                }

                Y1_text = stripWidth + textVertIndent;
                Y2_text = H - stripWidth - textVertIndent;

                textX = X1 + textPadding;
                textX_R = X2 - textPadding;
                if (normalPosCur1) {
                    // the labels are positioned inside the rectangular section of the bar
                    if (has_towBefore) textX = X1 + arrowWidth;
                    if (has_towAfter) textX_R = X2 - arrowWidth;
                }

                context.textBaseline = 'top';
                if (labStart1 != null) {
                    context.textAlign = 'left';
                    context.fillText(labStart1, textX, Y1_text);
                }
                if (labEnd1 != null) {
                    context.textAlign = 'right';
                    context.fillText(labEnd1, textX_R, Y1_text);
                }
                if (labMiddle1 != null) {
                    context.textAlign = 'center';
                    context.fillText(labMiddle1, textX_M, Y1_text);
                }

                textX = X1 + textPadding;
                textX_R = X2 - textPadding;
                if (normalPosCur2) {
                    // the labels are positioned inside the rectangular section of the bar
                    if (has_towBefore) textX = X1 + arrowWidth;
                    if (has_towAfter) textX_R = X2 - arrowWidth;
                }

                context.textBaseline = 'bottom';
                if (labStart2 != null) {
                    context.textAlign = 'left';
                    context.fillText(labStart2, textX, Y2_text);
                }
                if (labEnd2 != null) {
                    context.textAlign = 'right';
                    context.fillText(labEnd2, textX_R, Y2_text);
                }
                if (labMiddle2 != null) {
                    context.textAlign = 'center';
                    context.fillText(labMiddle2, textX_M, Y2_text);
                }

                return;
            } //  rowCnt === 2

            //LL:  here rowCnt === 3:

            //LL: for Text Labels: do not draw on Strips  + textVertIndent
            Y1_text = H3 + stripWidth + textVertIndent;
            Y2_text = H - H3 - stripWidth - textVertIndent;
            hBar_text = H - H3 * 2 - (stripWidth + textVertIndent) * 2;
            arrowHeight_text = Math.round(hBar_text / 2);

            // -- central line:

            textX = X1 + textPadding;
            textX_R = X2 - textPadding;
            if (normalPos) {
                //   normalPos vs squeezed
                // the labels are positioned inside the rectangular section of the bar
                if (has_towBefore) textX = X1 + arrowWidth;
                if (has_towAfter) textX_R = X2 - arrowWidth;
            }

            context.textBaseline = 'middle'; // align text vertically center
            if (text != null) {
                //   align text horizontally:
                context.textAlign = 'left';
                context.fillText(text, textX, Y1_text + arrowHeight_text);
                //context.strokeText(text, textX, arrowHeight);
            }
            if (textRight != null) {
                context.textAlign = 'right';
                context.fillText(textRight, textX_R, Y1_text + arrowHeight_text);
            }
            if (LabelMiddle != null) {
                context.textAlign = 'center';
                context.fillText(LabelMiddle, textX_M, Y1_text + arrowHeight_text);
            }

            // -- 1st and 3d lines:

            textX = X1 + textPadding;
            textX_R = X2 - textPadding;
            if (normalPosAbove) {
                // the labels are positioned inside the rectangular section of the bar
                if (has_towBefore) textX = X1 + arrowWidth;
                if (has_towAfter) textX_R = X2 - arrowWidth;
            }

            context.textBaseline = 'bottom';
            if (StartLabelAbove != null) {
                context.textAlign = 'left';
                context.fillText(StartLabelAbove, textX, Y1_text);
            }
            if (EndLabelAbove != null) {
                context.textAlign = 'right';
                context.fillText(EndLabelAbove, textX_R, Y1_text);
            }
            if (MiddleLabelAbove != null) {
                context.textAlign = 'center';
                context.fillText(MiddleLabelAbove, textX_M, Y1_text);
            }

            textX = X1 + textPadding;
            textX_R = X2 - textPadding;
            if (normalPosBelow) {
                // the labels are positioned inside the rectangular section of the bar
                if (has_towBefore) textX = X1 + arrowWidth;
                if (has_towAfter) textX_R = X2 - arrowWidth;
            }

            context.textBaseline = 'top';
            if (StartLabelBelow != null) {
                context.textAlign = 'left';
                context.fillText(StartLabelBelow, textX, Y2_text);
            }
            if (EndLabelBelow != null) {
                context.textAlign = 'right';
                context.fillText(EndLabelBelow, textX_R, Y2_text);
            }
            if (MiddleLabelBelow != null) {
                context.textAlign = 'center';
                context.fillText(MiddleLabelBelow, textX_M, Y2_text);
            }
        }
    }
}
